export const API = {
  MIDDLEWARE_URL: process.env.REACT_APP_MIDDLEWARE_URL,
  TOKEN: process.env.REACT_APP_MIDDLEWARE_API_TOKEN,
  ELEMENT_ENDPOINT: "/api/elements",
  SEARCH_ENDPOINT: "/api/search",
};
